import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	notFound: {
		display: 'block',
		margin: '110px auto 0',
	},
});
